const footerLinksData = [
  {
    title: "products",
    linkList: [{ item: "coffee", to: "/collections/coffee-blends/" }],
  },
  {
    title: "Company",
    linkList: [{ item: "About us", to: "about-us" }],
  },
  {
    title: "CUSTOMER INFO",
    linkList: [{ item: "lorem", to: "/" }],
  },
  {
    title: "Policies",
    linkList: [{ item: "lorem", to: "/" }],
  },
];

export default footerLinksData;
